import { Route, Routes, Navigate } from 'react-router-dom';
import ContainerProfile from '~/Containers/ContainerProfile';
import ContainerCategory from '~/Containers/ContainerCategory';
import { navigate } from '~/helpers/consts';
import { CREWS_CATEGORY, DOLLS_CATEGORY, ENSIGNS_CATEGORY, PERMOFLAGES_CATEGORY, PROFILE_PAGE, VEHICLE_CATEGORY } from '~/Actions/ActionCategory';

const Routing = () => (
    <Routes>
        <Route path={navigate[PROFILE_PAGE]} element={<ContainerProfile />} />
        <Route path={navigate[VEHICLE_CATEGORY]} element={<ContainerCategory category={VEHICLE_CATEGORY} />} />
        <Route path={navigate[CREWS_CATEGORY]} element={<ContainerCategory category={CREWS_CATEGORY} />} />
        <Route path={navigate[ENSIGNS_CATEGORY]} element={<ContainerCategory category={ENSIGNS_CATEGORY} />} />
        <Route path={navigate[DOLLS_CATEGORY]} element={<ContainerCategory category={DOLLS_CATEGORY} />} />
        <Route path={navigate[PERMOFLAGES_CATEGORY]} element={<ContainerCategory category={PERMOFLAGES_CATEGORY} />} />
        <Route path="*" element={<Navigate to={navigate[PROFILE_PAGE]} replace />} />
    </Routes>
);

export default Routing;
